import { Component, Input } from "@angular/core"
import { BasePostForm } from "./base-post-form.component"
import { SubmissionMutations } from "src/modules/submissions/submission.mutations"
import { successToast, errorToast } from "src/toaster"
import { postInContext } from "src/logic/post-states"

@Component({
  selector: 'white-label-form',
  template: `
    <h5 class="danger"> White Label Activity</h5>
    <div>
      <button
        class="btn btn-sm btn-no-border mb-4"
        tooltip="Click to toggle this submissions visibility for your client">
        <mat-slide-toggle color="primary"
                      [checked]="post?.wlVisible"
                      (change)="toggle()">

          <p class="d-inline">
            {{post.wlVisible ? ' This piece is visible to your client in Editspace.' : ' This piece is not visible in Editspace.'}}
          </p>
        </mat-slide-toggle>
      </button>
    </div>
    <div *ngIf="post?.wlVisible">
      <h5 class="danger mt-4">Client Feedback</h5>
      <div [innerHTML]="post?.wlUserFeedbackMessage"></div>
    </div>
    <div class="d-flex justify-content-between" *ngIf="post?.wlVisible">
      <button type="button" class="btn btn-xs btn-primary" style="margin-right: 10px;" (click)="onAskForFeedback()" [disabled]="!canAskForFeedback">Get client feedback</button>
      <button type="button" class="btn btn-xs btn-outline-tertiary close-button" style="margin-right: 10px;" (click)="onClose()">Cancel</button>
    </div>
    <div class="mt-3" *ngIf="canAskForFeedback && post?.wlVisible">
      <span class="text-muted small">
        This piece is view only.  Give your client the power to edit, approve, or reject. <a href="">Learn more</a>
      </span>
    </div>
    <div class="mt-3" *ngIf="!canAskForFeedback && post?.wlVisible">
      <span *ngIf="!awaitingEditing && !hasBeenApprovedOrRejected" class="text-muted small">
        Your client already has the power to edit, approve, or reject this piece.
      </span>
      <span *ngIf="awaitingEditing" class="text-muted small">
        You can't ask for more feedback while the writer is making revisions.
      </span>
    </div>
  `,
  styles: [`
    .nav-item {
      cursor:pointer;
    }
    .right-content {
      flex-direction: column;
      justify-content: flex-start;
    }
    .btn-no-border {
      border: none;
    }
  `]
})
export class WhiteLabelForm extends BasePostForm {
  saving = false;
  constructor(private submissionMutations: SubmissionMutations) {
    super()
  }
  toggle(): void {
    const wlVisible = !this.post.wlVisible
    this.submissionMutations.updatePost({ post: this.post, updates: { wlVisible } }).then(post => {
      if (post.wlVisible) {
        successToast('This piece is visible in Editspace.')
      } else {
        successToast('This piece is not visible in Editspace.')
      }
    })
  }

  onAskForFeedback(): void {
    this.saving = true
    this.submissionMutations.updatePost({post: this.post, transition: 'ask_for_feedback'}).then(post => {
      this.saving = false
      if (post) {
        successToast('Your client has been sent an email from Editspace asking for feedback.')
      } else {
        errorToast('There was a problem trying to get feedback. Please try again later.')
      }
    })
  }

  get canAskForFeedback(): boolean {
    return (['me', 'colleague'].includes(this.post.lockStatus)
      || postInContext(this.post, 'awaiting_agency_review'))
      && !this.awaitingEditing
      && !this.saving
  }

  get awaitingEditing(): boolean {
    return postInContext(this.post, 'awaiting_editing')
  }

  get hasBeenApprovedOrRejected(): boolean {
    return ['approve', 'reject'].includes(this.post.wlPostReview?.action)
  }

}
